import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { Search } from '@core-ds/icons/24';
import { BreakpointsContext } from 'core-components';
import * as HeaderActions from '../../actions';
import UserDropdown from './user_dropdown';
import AuthIcons from './auth_icons';
import WorkbenchDropdown from './workbench_dropdown';
import LanguageDropdownContainer from './language_dropdown_container';
import MiniCartDropdown from './mini_cart_dropdown';
import NotificationsDropdown from './notifications_dropdown';
import withNotifications from './with_notifications';

const Container = styled.div`
   display: flex;
   align-items: center;
`;

const SearchButton = styled.a`
   svg {
      transition: color 0.1s;
   }

   :hover svg {
      color: ${color.white};
   }
`;

const UserLogin = ({ userInfo }) => {
   return userInfo ? (
      <ConnectedUserDropdown
         username={userInfo.username}
         uniqueUsername={userInfo.uniqueUsername}
         profileUrl={userInfo.profileUrl}
         notificationsUrl={userInfo.notificationsUrl}
         avatar={userInfo.avatar}
         team={userInfo.team}
         isAdmin={userInfo.isAdmin}
      />
   ) : (
      <AuthIcons />
   );
};

const ConnectedNotificationsDropdown = withNotifications(NotificationsDropdown);
const ConnectedUserDropdown = withNotifications(UserDropdown);

const mapDispatchToProps = dispatch => ({
   toggleMobileSearch: value => dispatch(HeaderActions.toggleMobileSearch(value)),
});

const NavIcons = ({ dropdowns, toggleMobileSearch }) => {
   const breakpoints = React.useContext(BreakpointsContext);

   const showMobileSearch = () => {
      toggleMobileSearch(true);
      document.getElementById('mobileSearchForm').focus();
   };

   const { languageDropdown, userInfo } = dropdowns;
   const { languages, translationPreferencesUrl, machineTranslationRequested } = languageDropdown;

   if (breakpoints.isMobileTablet()) {
      return (
         <Container>
            {breakpoints.isMobile() && (
               <SearchButton onClick={showMobileSearch} href="#">
                  <Search color={color.gray4} focusable="false" />
               </SearchButton>
            )}
            <MiniCartDropdown />
            <UserLogin userInfo={userInfo} />
         </Container>
      );
   }

   return (
      <Container>
         <WorkbenchDropdown />
         {userInfo && (
            <ConnectedNotificationsDropdown notificationsUrl={userInfo.notificationsUrl} />
         )}
         <MiniCartDropdown />
         <LanguageDropdownContainer
            languages={languages}
            translationPreferencesUrl={translationPreferencesUrl}
            machineTranslationRequested={machineTranslationRequested}
         />
         <UserLogin userInfo={userInfo} />
      </Container>
   );
};

export default connect(null, mapDispatchToProps)(NavIcons);
